module.exports = window.lucide;